// extracted by mini-css-extract-plugin
export default {"element":"ElementsLoader_element__-Fvt9","shine":"ElementsLoader_shine__rBXZd"};